import { isValid, parse } from "date-fns";
import { formatDate } from "../utils";

const valueHelper = {
  date: (date) => {
    return date ? formatDate.format(date) : null;
  },
  time: (timeString) => {
    if (!timeString) return null;
    const parsed = parse(timeString, "HH:mm", new Date());
    return isValid(parsed) ? parsed : null;
  },
  text: (value) => {
    return value ? value : "";
  },
  autoComplete: (lista, valor) => {
    if (Array.isArray(valor)) {
      return valor.map((id) => {
        const objeto = lista.find((objeto) => objeto?.id == id);
        return objeto ? objeto : "";
      });
    } else {
      const objeto = lista.find((objeto) => objeto?.id == valor);
      return objeto ? objeto : "";
    }
  },
  multiple: (lista, valores) => {
    if (!valores?.length) return [];
    return valores.map((valor) => lista.find((item) => item.id === valor));
  },
};

export default valueHelper;
